import {RetroDemo} from '../../types/constEnums'


export default class DemoGenericMeetingStage {
  __init() {this.__typename = 'GenericMeetingStage'}
  __init2() {this.__isNewMeetingStage = 'GenericMeetingStage'}
  __init3() {this.isViewerReady = false}
  __init4() {this.isAsync = false}
  __init5() {this.endAt = null}
  __init6() {this.meetingId = RetroDemo.MEETING_ID}
  __init7() {this.isComplete = false}
  __init8() {this.isNavigable = false}
  __init9() {this.isNavigableByFacilitator = false}
  __init10() {this.startAt = new Date().toJSON()}
  __init11() {this.viewCount = 0}
  __init12() {this.readyCount = 0}
  __init13() {this.scheduledEndTime = null}
  __init14() {this.suggestedEndTime = null}
  __init15() {this.suggestedTimeLimit = null}
  __init16() {this.teamId = RetroDemo.TEAM_ID}
  __init17() {this.timeRemaining = null}
  
  

  constructor(id, phaseType) {;DemoGenericMeetingStage.prototype.__init.call(this);DemoGenericMeetingStage.prototype.__init2.call(this);DemoGenericMeetingStage.prototype.__init3.call(this);DemoGenericMeetingStage.prototype.__init4.call(this);DemoGenericMeetingStage.prototype.__init5.call(this);DemoGenericMeetingStage.prototype.__init6.call(this);DemoGenericMeetingStage.prototype.__init7.call(this);DemoGenericMeetingStage.prototype.__init8.call(this);DemoGenericMeetingStage.prototype.__init9.call(this);DemoGenericMeetingStage.prototype.__init10.call(this);DemoGenericMeetingStage.prototype.__init11.call(this);DemoGenericMeetingStage.prototype.__init12.call(this);DemoGenericMeetingStage.prototype.__init13.call(this);DemoGenericMeetingStage.prototype.__init14.call(this);DemoGenericMeetingStage.prototype.__init15.call(this);DemoGenericMeetingStage.prototype.__init16.call(this);DemoGenericMeetingStage.prototype.__init17.call(this);
    this.id = id
    this.phaseType = phaseType
  }
}
